const EXPANDABLE_INPUT_INIT_OFFSET = 85;
export function resolveChatContentHeight(args) {
  const {
    isDialogStylesEmpty,
    isExpandedInput,
    expandableTextHeight
  } = args;
  const heightOffset = EXPANDABLE_INPUT_INIT_OFFSET + expandableTextHeight;
  if (!isDialogStylesEmpty) {
    return isExpandedInput ? `calc(100% - ${heightOffset}px)` : 'calc(100% - 133px)';
  }
  return 'calc(100% - 120px)';
}
export function resolveChatContentStyle(args) {
  const {
    isDialogStylesEmpty,
    dialogStyles,
    standaloneStyles
  } = args;
  return !isDialogStylesEmpty ? dialogStyles : standaloneStyles;
}